import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "@/api/base";
import { Userdata } from "@/types/user";

const TAG = "authenitcation";

export const authenticationApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: "/pf-auth/" }),
  reducerPath: "authenticationApi",
  tagTypes: [TAG],
  endpoints: builder => ({
    getAuthenticatedUser: builder.query<Userdata, void>({
      providesTags: [TAG],
      query: () => ({
        url: "users/current",
      }),
    }),
  }),
});

export const { useGetAuthenticatedUserQuery } = authenticationApi;
